import tracker from '../../../components/tracker/publish'

interface ContentCuration {
  enabled: boolean
  enabledCommunityList: boolean
  curatedTopics: Array <any>
}

interface Category {
  title: string
  type: number
  heroImage: string
  contentCuration: ContentCuration
}

const getCategoryDescription = (type: number) => {
  let description: string = 'default'
  switch (type) {
    case 1:
        description = 'knowledgeBase';
      break;
    case 2:
        description = 'ideation';
      break;
    case 3:
        description = 'news';
      break;
  }
  return description
}

const actionTracker = (category: Category, action: string = 'Category Page Saved') => {
  tracker.trackEvent('userevent', {
    type: action,
    category_title: category.title,
    category_type: getCategoryDescription(category.type),
    category_has_hero_image: category.heroImage !== null,
    content_curation_visible: category.contentCuration.enabled,
    category_list_visible: category.contentCuration.enabledCommunityList,
    content_curation_number_of_links: category.contentCuration.curatedTopics.length
  })
}

export default actionTracker
